<template>
<div class="bio-container">
    <div class="bio-main sliding-background" id="sliding-background">
      <div class="bio-wall" :style="{ height: wall + 'px' }" v-show="tip">
        <div :style="{ left: wallLeft + 'px', width: (1000 - wallLeft) + 'px', height: wall + 'px' }" style="position:absolute; color:white; font-weight:bold; font-size:30px; background-color:black"></div>
        <div :style="{ left: (wallLeft + 1000) + 'px', width: (1000 - wallLeft) + 'px', height: wall + 'px' }" style="position:absolute; color:white; font-weight:bold; font-size:30px; background-color:black"></div>
        <div :style="{ left: (wallLeft + 2000) + 'px', width: (1000 - wallLeft) + 'px', height: wall + 'px' }" style="position:absolute; color:white; font-weight:bold; font-size:30px; background-color:black"></div>
      </div>
    </div>
    <!-- <div class="sliding-background2">
    </div> -->

    <div class="bio-bottom-bar">
      Ad soyad:&nbsp;<span class="bio-emg">{{ patientInfo }}</span>
      EMG Değeri:&nbsp;<span class="bio-emg" style="width: 70px;">{{ bioEmgValue }}</span>
      Ölçek (μV):&nbsp;<select class="bio-emg" @change="onChange($event)" v-model="config.domMax">
        <option>5</option>
        <option>10</option>
        <option>15</option>
        <option>20</option>
        <option>25</option>
        <option>30</option>
        <option>35</option>
        <option>40</option>
        <option>45</option>
        <option>50</option>
        <option>60</option>
        <option>70</option>
        <option>80</option>
        <option>90</option>
        <option>100</option>
        <option>125</option>
        <option>150</option>
        <option>175</option>
        <option>200</option>
        <option>500</option>
        <option>1000</option>
      </select>
      <div v-show="tip">
        Engel:&nbsp;
        <button style="width:50px; height:30px; padding:0; font-weight:bold" @click="wall = wall + 37">&uarr;</button>&nbsp;&nbsp;
        <button style="width:50px; height:30px; padding:0; font-weight:bold" @click="wall = wall - 37">&darr;</button>&nbsp;&nbsp;
      </div>
      <!-- <span  style="width: 70px;">{{ bioEmgValue }}</span> -->
      <button style="width:200px; height:30px;" @click="stop">Çalışmayı sonlandır</button>&nbsp;&nbsp;
    </div>
    <img id="bird" src="../assets/kus3.gif" v-show="show" :class="{ passive: isPassive }" style="position:absolute;z-index:100; width:300px; height:260px;">
</div>
</template>
<script>
import ReactiveDictClient from '../ReactiveDictClient'
// import GenericChart from '../GenericChart'
import Settings from '../settings'
// import _ from 'lodash'

const actionurl = 'http://' + Settings.host + ':6161/action'
const wsurl = (path) => 'ws://' + Settings.host + ':6161' + path

export default {
  data () {
    return {
      uiState: '',
      prState: '',
      isLocal: true,
      isWarning: false,
      isActive: true,
      chartVisible: false,
      patientInfo: '',
      reloader: Math.random(),
      helperMenuDisplay: '',
      deviceStatus: { ip_state: 'UNKNOWN' },
      isPassive: true,
      show: false,
      bird_vertical: 100,
      config: { domMin: 4, domMax: 200, ranMin: 50, ranMax: 700 },
      config_horizontal: { domMin: 251, domMax: 2048, ranMin: 0, ranMax: 900 },
      bioEmgValue: '',
      bioEmgValueInt: 0,
      scale: 200,
      wall: 37,
      wallLeft: 800,
      tip: 0
    }
  },
  methods: {
    onChange (event) {
      var vm = this
      vm.signalHandler(undefined, vm.bioEmgValueInt, false)
    },
    stop () {
      var vm = this

      vm.$http.get(actionurl + '/stop_biofeedback').then(response => {
        console.log(response.body)
        if (response.body.err === 'NOT_STARTED') {
          alert('Hata: Başlatılmış bir çalışma yok.')
          // window.close()
          window.location.href = '/'
        } else {
          // window.close()
          window.location.href = '/'
        }
      }, response => {
        console.log('Error starting exam')
      })
      console.log('Stopping')
    }
  },
  mounted () {
    var vm = this

    var tip = parseInt(vm.$route.params.tip, 10)
    vm.tip = tip

    var anim = 'slide 20s linear infinite'

    if (tip !== 0) {
      var zaman1 = parseInt(vm.$route.params.zaman1, 10)
      var zaman2 = parseInt(vm.$route.params.zaman2, 10)
      vm.wallLeft = 1000 * (zaman2 / (zaman1 + zaman2))
      console.log('vm.wallLeft', vm.wallLeft)

      anim = 'slide ' + (zaman1 + zaman2) + 's linear infinite'
    }

    console.log(anim)
    document.getElementById('sliding-background').style.animation = anim

    console.log(tip, zaman1, zaman2)

    var enableHorizontalMovement = false

    var signalHandler = function (isnp, val, init) {
      if (!init) console.log(isnp, ' signalHandler')
      if (isnp) return
      if (!init) { vm.bioEmgValueInt = parseInt(val); vm.bioEmgValue = parseInt(val) + ' μV' }
      // vm.deviceStatus.ip_state = val
      var element = document.getElementById('bird')
      if (val >= vm.config.domMin) {
        if (!init) { vm.isPassive = false }
        var result = vm.config.ranMin + ((val - vm.config.domMin) / Math.abs(vm.config.domMax - vm.config.domMin)) * Math.abs(vm.config.ranMax - vm.config.ranMin)
        result = parseInt(result, 10)

        if (enableHorizontalMovement && result > vm.config.ranMax) {
          var result2 = vm.config_horizontal.ranMin + ((val - vm.config_horizontal.domMin) / Math.abs(vm.config_horizontal.domMax - vm.config_horizontal.domMin)) * Math.abs(vm.config_horizontal.ranMax - vm.config_horizontal.ranMin)
          element.style.left = vm.bird_vertical + result2 + 'px'
          result = vm.config.ranMax
        } else {
          element.style.left = vm.bird_vertical + 'px'
        }

        element.style.bottom = result + 'px'
        // console.log('Valid signal, set to', element.style.bottom)
      } else {
        console.log('Invalid signal, position not changed')
      }
    }

    vm.signalHandler = signalHandler

    console.log('>>>')
    document.getElementById('bird').style.transition = 'all 0.1s linear'
    // document.getElementById('bird').style.top = vm.config.ranMin + 'px'
    vm.show = true

    var dummySignal = vm.config.domMin

    signalHandler(undefined, vm.config.domMin, true)

    var moveSelection = function (evt) {
      var element = document.getElementById('bird')
      var step = 30

      switch (evt.keyCode) {
        case 38:
          dummySignal += step
          signalHandler(false, dummySignal)
          break
        case 40:
          dummySignal -= step
          if (dummySignal < vm.config.domMin) { dummySignal += step }
          signalHandler(false, dummySignal)
          break
      }
      console.log(element.style.bottom)
    }

    window.addEventListener('keydown', moveSelection)

    var addr = wsurl('/websocket')

    var db = new ReactiveDictClient(addr)

    if (Settings.deviceHelper) {
      vm.helperMenuDisplay = 'initial'
      document.body.style.backgroundColor = 'lightgray'
    } else {
      vm.helperMenuDisplay = 'none'
    }

    db.on('connecting', function () {
      vm.uiState = 'CONNECTING'
    })

    db.on('disconnected', function () {
      vm.isPassive = true
    })

    db.on('SOCKET_INFO/isLocal', function (isnp, val) {
      vm.isLocal = val
    })

    db.on('Bio/patient_info', function (isnp, val) {
      vm.patientInfo = val
    })

    db.on('Bio/emg', signalHandler)

    db.connect()
  },
  created () {
    // var vm = this

  }

}
</script>

<style>
/* merriweather-regular - latin_latin-ext */
@font-face {
  font-family: 'Merriweather';
  font-style: normal;
  font-weight: 400;
  src: local('Merriweather Regular'), local('Merriweather-Regular'),
       url('../assets/fonts/merriweather-v19-latin_latin-ext-regular.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('../assets/fonts/merriweather-v19-latin_latin-ext-regular.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* merriweather-700 - latin_latin-ext */
@font-face {
  font-family: 'Merriweather';
  font-style: normal;
  font-weight: 700;
  src: local('Merriweather Bold'), local('Merriweather-Bold'),
       url('../assets/fonts/merriweather-v19-latin_latin-ext-700.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('../assets/fonts/merriweather-v19-latin_latin-ext-700.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* merriweather-900 - latin_latin-ext */
@font-face {
  font-family: 'Merriweather';
  font-style: normal;
  font-weight: 900;
  src: local('Merriweather Black'), local('Merriweather-Black'),
       url('../assets/fonts/merriweather-v19-latin_latin-ext-900.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('../assets/fonts/merriweather-v19-latin_latin-ext-900.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}

/* open-sans-regular - latin_latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  src: local('Open Sans Regular'), local('OpenSans-Regular'),
       url('../assets/fonts/open-sans-v15-latin_latin-ext-regular.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('../assets/fonts/open-sans-v15-latin_latin-ext-regular.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}

.sliding-background {
  background: url("../assets/1036682.jpg") repeat-x;
  /* height: 1900px; */
  background-position: bottom;
  background-size: 1000px 100%; /* it's important to set width equal to image's (auto does not work correctly) */
  width: 3000px;
  /* animation: slide 3s linear infinite; */
  /* full image (1000px slides in 20 seconds) */

  /* perspective:10px;  */
  /* backface-visibility:none; */
}

.bio-wall div {
    transition: all 0.2s linear;
    background: url("../assets/brick.jpg") repeat;
}
.bio-wall {
  transition: all 0.2s linear;
  width: 3000px;
  /* height:40px; */
  /* background-size: 1000px 100%; */
  /* it's important to set width equal to image's (auto does not work correctly) */
  /* background: url("../assets/wall.png") repeat; */
  /* background-color: blue; */
  bottom:0;
  position: absolute;
}

@keyframes slide{
  0%{
    transform: translate3d(0, 0, 0);
  }
  100%{
    transform: translate3d(-1000px, 0, 0);
  }
}

.passive { opacity: 0.5;}

.bio-container {
  display: flex;
  flex-flow: column;
  height: 100vh;
  overflow: hidden;
  /* min-height: 150px; */
  /* border: 1px solid red; */
  transform:translate3d(0,0,0);
  perspective: 1000;
  backface-visibility: hidden;
}
.bio-main {
  flex: 1;
  background-color: green;

  transform:translate3d(0,0,0);
  perspective: 1000;
  backface-visibility: hidden;
}

.bio-bottom-bar {
  transform:translate3d(0,0,0);
  perspective: 1000;
  backface-visibility: hidden;

  touch-action: none;
  display: flex;
  align-items: center;
  height: 55px;
  background-color: gainsboro;
  padding-left: 15px;
  /* background-color: #1B582F; */
  /* background-color: yellow; */

  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
}

.bio-emg {
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;

  text-align: right;
  background-color: #ccc;
  padding: 6px;
  /* margin-left: 15px; */
  margin-right: 30px;
  border: solid 1px #000;
}

</style>



// WEBPACK FOOTER //
// src/components/Biofeedback.vue